import React from "react";

const ShowPageSkeleton: React.FC = () => (
  <div className="v3 show-page-skeleton">
    <div className="skeleton-block skeleton-block--hero" />

    <div className="show-page-skeleton_section">
      <div className="show-page-skeleton_badges">
        <div className="skeleton-block skeleton-block--badge" />
        <div className="skeleton-block skeleton-block--badge" />
      </div>
      <div className="skeleton-block skeleton-block--title" />
      <div className="skeleton-block skeleton-block--title skeleton-block--title-short" />
    </div>

    <div className="show-page-skeleton_section">
      <div className="skeleton-block skeleton-block--card" />
    </div>

    <div className="show-page-skeleton_section">
      <div className="skeleton-block skeleton-block--card skeleton-block--card-tall" />
    </div>

    <div className="show-page-skeleton_bottom-bar">
      <div className="show-page-skeleton_bottom-bar-info">
        <div className="skeleton-block skeleton-block--bar-text skeleton-block--bar-text-short" />
        <div className="skeleton-block skeleton-block--bar-text" />
      </div>
      <div className="skeleton-block skeleton-block--bar-btn" />
    </div>
  </div>
);

export default ShowPageSkeleton;
